/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type CreateWidgetDialog_surveys = {| |};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CreateWidgetDialog_surveys",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "WidgetForm_surveys",
      "args": null
    }
  ],
  "type": "SurveyConnection"
};

module.exports = fragment;



// WEBPACK FOOTER //
// ./src/scenes/Report/components/ReportWrapper/components/CreateWidgetDialog/__generated__/CreateWidgetDialog_surveys.graphql.js